import { AIR_KITCHEN_ROUTE, POS_ROUTE } from "../../constants/constants"

export const PRODUCTS_ROUTE = POS_ROUTE + "/products"
export const CATEGORIES_ROUTE = POS_ROUTE + "/categories"
export const CUSTOMIZATION_ROUTE = POS_ROUTE + "/customizations"

export const INVENTORY_ROUTE = POS_ROUTE + "/inventory-list"
